import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DailyfactPage } from './dailyfact.page';

const routes: Routes = [
  {
    path: '',
    component: DailyfactPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DailyfactPageRoutingModule {}
